import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import Choose from "../../../../../styles/img/choose.png"
import Enjoy from "../../../../../styles/img/enjoy.png"
import Rate from "../../../../../styles/img/rate.png"
import {UiHowSectionWorkCol,UiHowSectionWorkColHeading} from"../../../components/common/UiHowSectionWorkCol"

export default function HowShopWorks(props) {


    return (
        <>
            <UiSingleRow>
                <UiCol lg="2"><UiHowSectionWorkColHeading title="How Shop Works"/></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        <UiHowSectionWorkCol heading="Choose" image={Choose} content="Select the item you like and start spending your points."/>
                        <UiHowSectionWorkCol heading="Enjoy" image={Enjoy} content="Vouchers are ready immediately and experiences it’s just a 24hr wait. Have fun."/>
                        <UiHowSectionWorkCol heading="Rate" image={Rate} content="Help the sherbet community by rating your purchases."/>
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}
